<template>
  <div>
    <v-dialog v-model="dialog" max-width="800px">
      <template v-slot:activator="{ on }">
        <v-btn v-if="!discountInfo" v-on="on" class=" text-capitalize font-weight-bold" color="primary"> <v-icon small class="me-1">mdi-plus</v-icon>Add </v-btn>
        <v-icon v-else v-on="on" @click="onEditPromoCode" class="dark--text">mdi-square-edit-outline</v-icon>
      </template>
      <v-card class="pa-3" color="pop_bg">
        <v-card-title>
          <span v-if="discountInfo" class="text-h6 dark--text">Update Discount</span>
          <span v-else class="text-h6 dark--text">Create Discount</span>
          <v-spacer></v-spacer>
          <v-btn color="dark" text @click="close"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-form class="pa-sm-6 mt-n6" @submit="createDiscount()" v-model="valid" ref="form">
          <v-card-text>
            <v-container>
              <v-layout wrap>
                <v-flex xs12 sm4 md2 class="mt-2">
                  <h4 class="text-body-2 dark--text">Title (English)</h4>
                </v-flex>
                <v-flex xs12 sm8 md3>
                  <v-text-field v-model="titleEn" :rules="[requiredValidator('title (english)')]" solo dense></v-text-field>
                </v-flex>

                <v-flex xs1 sm2 md1 class="ml-5 mt-n3">
                  <v-checkbox v-model="isActive" label="Active">Active</v-checkbox>
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs12 sm4 md2 class="mt-2">
                  <h4 class="text-body-2 dark--text">Title (Aabic)</h4>
                </v-flex>
                <v-flex xs12 sm8 md3>
                  <v-text-field v-model="titleAr" :rules="[requiredValidator('title (arabic)')]" solo dense></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout wrap class="mt-4">
                <v-flex xs12 sm4 md2 class="mt-n2">
                  <h4 class="text-body-2 dark--text">Discount</h4>
                </v-flex>
                <v-flex xs12 sm8 md3 class="mt-sm-n4">
                  <v-text-field solo dense v-model="discount" :append-icon="inPercentage == true ? 'mdi-percent' : ''" type="number" min="0" :rules="[requiredValidator('discount')]"></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 md2 class="mt-2 mt-md-n2 ms-md-16">
                  <h4 class="text-body-2 dark--text">Discount Type</h4>
                </v-flex>
                <v-flex xs12 sm5 md3 class="mt-md-n6">
                  <v-radio-group v-model="inPercentage" :mandatory="true" column>
                    <v-radio label="Fixed Amount" :value="false"></v-radio>

                    <v-radio label="Percentage" :value="true"></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>
              <v-layout> </v-layout>

              <v-layout wrap>
                <v-flex xs12 sm4 md2 class="mt-1 " v-if="inPercentage">
                  <h4 class="text-body-2 dark--text">
                    Maximum Discount
                  </h4>
                </v-flex>
                <v-flex xs12 sm8 md3 class="mt-1" v-if="inPercentage">
                  <v-text-field solo dense v-model="maxDiscountAmount" type="number" min="0" :rules="[requiredValidator('discount')]"></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout wrap>
                <v-flex xs12 sm4 md2 class="mt-2">
                  <h4 class="text-body-2 dark--text">Start Date</h4>
                </v-flex>
                <v-flex xs12 sm8 md3>
                  <v-menu v-model="menuStartDate" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        solo
                        dense
                        :value="formatStartDate"
                        append-icon="fa-calendar-alt dark--text"
                        readonly
                        :rules="[requiredValidator('start date')]"
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker color="primary" v-model="startDate" @input="menuStartDate = false" :min="today"></v-date-picker>
                  </v-menu>
                </v-flex>

                <v-flex xs12 sm4 md2 class="mt-2 ms-md-16">
                  <h4 class="text-body-2 dark--text">End Date</h4>
                </v-flex>
                <v-flex xs12 sm8 md3>
                  <v-menu v-model="menuEndDate" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        solo
                        dense
                        :value="formatEndDate"
                        append-icon="fa-calendar-alt dark--text"
                        readonly
                        :rules="[requiredValidator('end date')]"
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker color="primary" v-model="endDate" @input="menuEndDate = false" :min="new Date(startDate) | moment('YYYY-MM-DD')"></v-date-picker>
                  </v-menu>
                </v-flex>
              </v-layout>

              <v-layout wrap>
                <v-flex xs12 sm4 md2 class="mt-2">
                  <h4 class="text-body-2 dark--text">Applicable for</h4>
                </v-flex>

                <v-flex xs12 sm8 md3 class="mt-n3">
                  <v-checkbox v-model="applicableFor" @change="changeApplicable()" value="ALL" label="All"></v-checkbox>
                </v-flex>
                <v-flex xs12 sm8 md3 class="mt-n3">
                  <v-checkbox v-model="applicableFor" @change="changeApplicable()" value="PRODUCT" label="Product"></v-checkbox>
                </v-flex>

                <v-flex xs12 sm8 md3 class="mt-n3">
                  <v-checkbox v-model="applicableFor" @change="changeApplicable()" value="CATEGORY" label="Category"></v-checkbox>
                </v-flex>
              </v-layout>

              <v-layout row wrap>
                <span class="error--text"> Priority goes to Product >> Category >> All </span>
              </v-layout>
              <v-layout row wrap v-if="applicableFor == 'PRODUCT'">
                <v-flex xs12 sm8 md6 class="mt-3">
                  <v-autocomplete solo dense label="Product" :items="products" item-text="nameEn" return-object v-model="chooseProduct" item-value="_id"></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm8 md6 class="mt-3">
                  <v-btn text class="error--text text-capitalize font-weight-bold" color="primary" @click="addProduct"><v-icon small class="me-1">mdi-plus</v-icon> </v-btn>
                </v-flex>
              </v-layout>

              <v-layout row wrap v-if="applicableFor == 'CATEGORY'">
                <v-flex xs12 sm8 md6 class="mt-3">
                  <v-autocomplete
                    solo
                    dense
                    label="Category"
                    :items="categories"
                    item-text="nameEn"
                    clearable
                    deletable-chips
                    small-chips
                    v-model="categoriesSelected"
                    multiple
                    item-value="_id"
                  ></v-autocomplete>
                </v-flex>
              </v-layout>

              <v-layout row wrap v-if="applicableFor == 'PRODUCT'">
                <v-flex xs12 sm8 md6 v-for="(item, index) in selectedProducts" :key="item._id">
                  {{ index + 1 }} - {{ item.nameEn }}, Price: {{ item.price }}
                  <v-btn text class="error--text text-capitalize font-weight-bold" color="primary" @click="removeProduct(item)"><v-icon small class="me-1">mdi-delete</v-icon> </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions class="mb-sm-n4 mt-n6">
            <v-spacer></v-spacer>
            <v-btn color="primary" class=" light--text text-capitalize" :width="$vuetify.breakpoint.smAndUp ? 120 : 90" :loading="btnloading" @click="createDiscount" :disabled="!valid">Add</v-btn>
          </v-card-actions>
          <!-- {{ isPercentage }} -->
        </v-form>
        <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
          {{ snackText }}
        </v-snackbar>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" timeout="3000" right top color="success">{{ text }}</v-snackbar>
  </div>
</template>

<script>
import { requiredValidator, percentageValidator } from "../../core/methods/validations";
import { DATE_FORMAT } from "../../utils/utils";
import moment from "moment";
// import AssignPackages from "./AssignPackages.vue";
export default {
  components: {},
  props: {
    discountInfo: {
      required: true,
    },
  },
  data() {
    return {
      categoriesSelected: [],
      requiredValidator: requiredValidator,
      today: new Date().toISOString().slice(0, 10),
      percentageValidator,
      moment: moment,
      chooseProduct: "",
      applicableFor: "ALL",
      selectedProducts: [],
      dialog: false,
      inPercentage: false,
      discount: "",
      maxDiscountAmount: 0,
      btnloading: false,
      nowDate: new Date(),
      isActive: true,
      titleAr: "",
      titleEn: "",
      snackbar: false,
      text: "",
      valid: true,
      startDate: "",
      endDate: "",
      menuStartDate: false,
      menuEndDate: false,
      variables: {
        limit: 25,
        skip: 0,
      },
      snack: false,
      snackColor: "",
      snackText: "",
      enableAddBtn: true,
      products: [],
      categories: [],
    };
  },
  apollo: {
    getAllPackages() {
      return {
        query: require("@/menu-packages/api/getAllPackagesWithChoice.graphql"),
        variables: this.variables,
        result({ data, loading }) {
          this.loading = loading;
          this.packagesList = data.getAllPackages.packages.filter(x => x.active);
        },
      };
    },
    getAllProductCategories() {
      return {
        query: require("@/ecommerse/api/getAllProductCategories.graphql"),
        variables: this.variables,
        result({ data, loading }) {
          console.log(data);
          this.categories = data.getAllProductCategories;

          if (this.discountInfo) {
            if (this.discountInfo.categories.length) {
              this.categoriesSelected = this.discountInfo.categories;
            }
          }

          this.loading = loading;
        },
      };
    },
  },
  created() {
    this.getAllProducts();
    if (this.discountInfo) {
      this.titleEn = this.discountInfo.titleEn;
      this.titleAr = this.discountInfo.titleAr;
      this.discount = this.discountInfo.discount;
      this.inPercentage = this.discountInfo.inPercentage;
      this.maxDiscountAmount = this.discountInfo.maxDiscountAmount;
      this.applicableFor = this.discountInfo.applicableFor;
      this.maxDiscountAmount = this.discountInfo.maxDiscountAmount;

      this.startDate = new Date(parseInt(this.discountInfo.startDate));
      this.endDate = new Date(parseInt(this.discountInfo.endDate));
    }
  },
  methods: {
    addProduct() {
      if (this.chooseProduct) {
        let hasItem = this.selectedProducts.find(x => x._id == this.chooseProduct._id);
        if (!hasItem) {
          this.selectedProducts.push(this.chooseProduct);
        }
      }
    },
    changeApplicable() {
      this.selectedProducts = [];
      this.categoriesSelected = [];
      this.chooseProduct = "";
    },
    removeProduct(item) {
      this.selectedProducts = this.selectedProducts.filter(x => x._id != item._id);
    },

    getAllProducts() {
      this.loading = true;
      this.$apollo
        .query({
          query: require("@/ecommerse/api/getAllProducts.graphql"),
          variables: {
            limit: 0,
            skip: 0,
          },
        })

        .then(data => {
          this.loading = false;
          if (data.data.getAllProducts) {
            this.products = data.data.getAllProducts.products;
            debugger;
            if (this.discountInfo) {
              if (this.discountInfo.products.length) {
                this.selectedProducts = [];
                this.discountInfo.products.forEach(element => {
                  let selected = this.products.find(x => x._id == element);
                  if (selected) {
                    this.selectedProducts.push(selected);
                  }
                });
              }
            }
          }
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
        });
    },

    createDiscount() {
      let minimumProductPrice = 10000;

      // debugger;
      let products = new Array();
      let categories = new Array();
      if (this.applicableFor == "PRODUCT") {
        this.selectedProducts.forEach(element => {
          products.push(element._id);
          if (element.price < minimumProductPrice) {
            minimumProductPrice = element.price;
          }
        });

        if (!this.inPercentage) {
          if (parseFloat(this.discount) >= minimumProductPrice) {
            this.snack = true;
            this.snackColor = "error";
            this.snackText = "Discount amount should be less than the product amount.";
            return false;
          }
        }
      }

      if (this.applicableFor == "CATEGORY") {
        this.categoriesSelected.forEach(element => {
          categories.push(element);
        });
      }
      this.btnloading = true;
      this.$apollo
        .mutate({
          mutation: this.discountInfo ? require("../api/updateShopDiscount.graphql") : require("../api/createShopDiscount.graphql"),
          variables: {
            id: this.discountInfo ? this.discountInfo._id : null,
            input: {
              startDate: this.startDate,
              endDate: this.endDate,
              titleEn: this.titleEn,
              titleAr: this.titleAr,
              isActive: this.isActive,
              discount: parseFloat(this.discount),
              inPercentage: this.inPercentage,
              maxDiscountAmount: parseFloat(this.maxDiscountAmount),
              applicableFor: this.applicableFor,
              products: products,
              categories: categories,
            },
          },
        })
        .then(() => {
          this.$root.$emit("updateShopDiscount");
          this.btnloading = false;
          this.dialog = false;

          this.text = "Discount  Updated";
          if (!this.discountInfo) {
            this.planChoices = [];
            this.isNewPlan = false;
            this.$refs.form.reset();
            this.isActive = false;
            this.text = "Discount  Added";
            this.startDate = "";
            this.endDate = "";
          }
          this.snackbar = true;
        })
        .catch(error => {
          this.btnloading = false;
          if (error.graphQLErrors != null) {
            // debugger;
            if (error.message === "GraphQL error: ALREADY_EXIST") {
              this.doesPromoCodeExist = true;
            } else {
              this.text = error.graphQLErrors[0].message;
              this.snackbarColor = "error";
              this.snackbar = true;
            }
          }
        });
    },

    close() {
      this.dialog = false;
    },
  },

  computed: {
    formatStartDate() {
      return this.startDate ? moment(this.startDate).format(DATE_FORMAT) : "";
    },
    formatEndDate() {
      return this.endDate ? moment(this.endDate).format(DATE_FORMAT) : "";
    },
    packagesWithSno() {
      return this.planChoices.map((d, index) => ({ ...d, sno: index + 1 }));
    },
  },
};
</script>
<style>
.theme--light.v-list-item--active:hover::before,
.theme--light.v-list-item--active::before {
  opacity: 0.2 !important;
}
</style>
